import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import ModalButton from 'components/Modal/Button'

import Brand from 'helpers/brand'

import { ButtonContainer } from 'styles/shared'
import { color } from 'styles/colors'

import useDealer from 'hooks/useDealer'

type Props = {
  customerName: string,
  customerEmail: string,
  isEmailSent: boolean,
  sendEmail: (notes: string) => void
  resetAndCloseModal
}
const EmailSystemReport = ({
  customerName,
  customerEmail,
  sendEmail,
  resetAndCloseModal,
  isEmailSent
}: Props) => {
  const { dealer: { name: dealerName, email: dealerEmail }, isDealerLoaded } = useDealer()

  const [emailData, setEmailData] = useState({
    notes: '',
    customerName: '',
    customerEmail: ''
  })

  useEffect(() => {
    if (isDealerLoaded) {
      setEmailData(prev => ({
        ...prev,
        customerName,
        customerEmail,
        notes: `
          Hello ${customerName}, 
          <br /><br />
          Your HVAC system report, generated for your system from ${Brand.productName()} is attached. 
          If you have any concerns, contact ${dealerName} at ${dealerEmail}.`
      }))
    }
  }, [dealerEmail, dealerName, customerName, customerEmail, isDealerLoaded])

  return (
    <S.Container>
      <S.FieldWrapper>
        <S.Field> <span>Dealer:</span> {dealerName}</S.Field>
        <S.Field> <span>From:</span> {Brand.noReplySender()}</S.Field>
      </S.FieldWrapper>
      <S.FieldWrapper>
        <S.Field> <span>Customer Name:</span> {customerName}</S.Field>
        <S.Field> <span>Customer Email:</span> {customerEmail}</S.Field>
      </S.FieldWrapper>
      <S.FieldWrapper>
        <S.NoteArea dangerouslySetInnerHTML={{ __html: emailData.notes }} />
      </S.FieldWrapper>
      <S.FieldWrapper>
        <S.MessageSubtext>The text in this email cannot be changed.</S.MessageSubtext>
      </S.FieldWrapper>
      <S.ButtonContainer noBorder>
        <ModalButton onPress={resetAndCloseModal} decoration="secondary" text="Cancel" disabled={isEmailSent} />
        <ModalButton onPress={() => sendEmail(emailData.notes)} decoration="positive" text="Send Email" showSpinner={isEmailSent} />
      </S.ButtonContainer>
    </S.Container>
  )
}

const S = {
  Container: styled.div`
    display: flex;
    gap: 25px;
    flex-direction: column;
    font-size: 14px;
  `,
  FieldWrapper: styled.div`
    margin-bottom: 4px;
  `,
  NoteArea: styled.div`
      background-color: ${color('chartBackground')};
      padding: 8px;
      border-radius: 10px;
      color: ${color('emailFormText')};
  `,
  Field: styled.div`
    color: ${color('emailFormText')};
    span{
      font-weight: bold;
    }
  `,
  ButtonContainer: styled(ButtonContainer)`
    margin-top: 0;
  `,
  MessageSubtext: styled.span`
    color: ${color('secondaryText')};
    font-style: italic;
  `
}
export default EmailSystemReport
